import {
  CyclabilityZoneService,
  Geogroup,
  GeogroupService,
  Partner,
} from '@geovelo-frontends/commons';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './query-keys';
import { resolveQueryData } from './resolve-query-data';

async function attachCountryCode(geogroup: Geogroup): Promise<Geogroup> {
  if (geogroup.place) {
    const {
      zones: [country],
    } = await CyclabilityZoneService.getZones({
      administrativeLevel: 'COUNTRY',
      point: geogroup.place.point,
      query: '{id, administrative_level, name, country_code}',
    });

    geogroup.countryCode = (country && country.countryCode) || null;
  } else geogroup.countryCode = null;

  return geogroup;
}

async function fetchGeogroup(geoGroupId: number): Promise<Geogroup> {
  try {
    const geogroup = await GeogroupService.getGeogroup({ geoGroupId });
    return await attachCountryCode(geogroup);
  } catch (err) {
    console.error(err);

    const { group: geogroup } = await GeogroupService.joinGeogroup(geoGroupId);
    return await attachCountryCode(geogroup);
  }
}

export default function usePartnerGeogroupQuery(partner: Partner | null | undefined) {
  const enabled = !!partner?.geoGroupId;

  const query = useQuery({
    queryKey: queryKeys.partnerGeogroup.all(partner?.id),
    queryFn: () => fetchGeogroup(partner?.geoGroupId as number),
    enabled,
    staleTime: 60_000,
  });

  const data = resolveQueryData(
    query.data,
    !partner ? undefined : !partner.geoGroupId || query.isError ? null : undefined,
  );

  return { ...query, data };
}
